export default __webpack_public_path__ + "static/media/info_icon.f6901827.svg";